import { createTheme } from '@mui/material/styles'

const marketsColour = '#008C9F'
export default createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: marketsColour,
            '&:hover': { backgroundColor: marketsColour }
          }
        },
        today: { color: marketsColour, borderColor: marketsColour }
      }
    },
    MuiDatePickerToolbar: {
      styleOverrides: { root: { backgroundColor: marketsColour } }
    },
    MuiInputBase: {
      styleOverrides: {
        root: { cursor: 'pointer' },
        input: { cursor: 'pointer', userSelect: 'none' }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
            borderColor: marketsColour
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: marketsColour }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: { root: { '&.Mui-focused': { color: marketsColour } } }
    }
  }
})
